import { ReactElement, ReactNode } from 'react';
import { debug } from 'zf-web-infra';
import { ColumnProps } from 'antd/es/table';
import { MappingProps } from '../types';

export function Mapping<T>(props: MappingProps<T>): ReactElement | null {
  debug.common('Map', props);
  return null;
}

Mapping.displayName = 'Mapping';

export function getMappingProps<T>(child: ReactElement<ColumnProps<T>>): ColumnProps<T> {
  const { mapping } = child.props as MappingProps<T>;
  return {
    ...child.props, render: (value): ReactNode => mapping[value]
  };
}
